import { Api } from './api'

class Microsoft extends Api {
    constructor() {
        super('https://graph.microsoft.com/v1.0')
    }
}

export const MAPI = new Microsoft()
